// removed by extract-text-webpack-plugin
module.exports = {"page":"_3AzBP_V1WP26Ph0tK-asf5","content":"sk-exuK4U44Gt6baGqjb7","logo":"_1p9RS529rI7KmEQ1H2psXp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/PageEntry/PageEntry.styl
// module id = 118
// module chunks = 0